import { render } from "./UserCreate.vue?vue&type=template&id=3c2c55fd&scoped=true&ts=true"
import script from "./UserCreate.vue?vue&type=script&lang=ts"
export * from "./UserCreate.vue?vue&type=script&lang=ts"

import "./UserCreate.vue?vue&type=style&index=0&id=3c2c55fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2c55fd"]])

export default __exports__